// Este script se encarga de eliminar el regalo de la página de carrito cuando no hya 3 productos para comprar
// También se vuelve a añadir si se vuelven a cumplir las condiciones
// gift-cart-sync.js - Sincroniza el producto de regalo en el carrito
// VERSIÓN CON SELECTOR VISUAL DE MINIATURAS (CON URLs DIRECTAS)

document.addEventListener('DOMContentLoaded', function() {
  
  // Solo ejecutar en la página del carrito
  if (!window.location.pathname.includes('/cart')) return;
  
  // ============================================
  // CONFIGURACIÓN - LISTA DE IDs
  // ============================================
  var PAID_PRODUCT_IDS = [
    '54936981143929', // black_carbon
    '54937013813625', // brown_mole
    '54937013682553', // green_forest
    '54937013715321', // red_flower
    '54937013748089', // black_vulture
    '54937013780857', // blue_royal
    '54937013879161', // light_grey
    '54937013911929'  // dark_grey
  ];
  
  var GIFT_PRODUCT_IDS = [
    '56844488868217', // regalo black_carbon
    '56844494111097', // regalo brown_mole
    '56844485984633', // regalo green_forest
    '56844481724793', // regalo red_flower
    '56844501385593', // regalo black_vulture
    '56844490899833', // regalo blue_royal
    '56844496503161', // regalo light_grey
    '56844466061689'  // regalo dark_grey
  ];
  
  // Mapa de nombres bonitos para mostrar
  var GIFT_NAMES = {
    '56844488868217': 'Black Carbon',
    '56844494111097': 'Brown Mole',
    '56844485984633': 'Green Forest',
    '56844481724793': 'Red Flower',
    '56844501385593': 'Black Vulture',
    '56844490899833': 'Blue Royal',
    '56844496503161': 'Light Grey',
    '56844466061689': 'Dark Grey'
  };
  
  // Mapa para saber qué regalo corresponde a qué color (opcional)
  var GIFT_BY_COLOR = {
    '54936981143929': '56844488868217', // black_carbon -> regalo black_carbon
    '54937013813625': '56844494111097', // brown_mole -> regalo brown_mole
    '54937013682553': '56844485984633', // green_forest -> regalo green_forest
    '54937013715321': '56844481724793', // red_flower -> regalo red_flower
    '54937013748089': '56844501385593', // black_vulture -> regalo black_vulture
    '54937013780857': '56844490899833', // blue_royal -> regalo blue_royal
    '54937013879161': '56844496503161', // light_grey -> regalo light_grey
    '54937013911929': '56844466061689'  // dark_grey -> regalo dark_grey
  };
  
  // ============================================
  // URLs DE LAS IMÁGENES (código 02)
  // ⚠️ IMPORTANTE: RELLENA ESTAS URLs CON LAS IMÁGENES REALES
  // ============================================
  var IMAGENES_COLORES = {
    'bc': '//e-guardian.es/cdn/shop/files/cartera-aluminio-compacta-hombre.jpg?v=1773266812&width=1946',
    'bm': '//e-guardian.es/cdn/shop/files/cartera-tarjetas-aluminio-minimalista.jpg?v=1773266812&width=1946',
    'gf': '//e-guardian.es/cdn/shop/files/cartera-metalica-delgada-hombre.jpg?v=1773266812&width=1946',
    'fx': '//e-guardian.es/cdn/shop/files/cartera-minimalista-segura-rfid.jpg?v=1773266812&width=1946',
    'bv': '//e-guardian.es/cdn/shop/files/cartera-minimalista-bolsillo-delgado.jpg?v=1773266683&width=1946',
    'br': '//e-guardian.es/cdn/shop/files/cartera-minimalista-elegante-hombre.jpg?v=1773266812&width=1946',
    'lg': '//e-guardian.es/cdn/shop/files/cartera-minimalista-hombre-tarjetas.jpg?v=1773266812&width=1946',
    'dg': '//e-guardian.es/cdn/shop/files/cartera-moderna-hombre-minimalista.jpg?v=1773266812&width=1946'
  };
  
  // ============================================
  // VARIABLES GLOBALES
  // ============================================
  var selectorActivo = false;
  
  // ============================================
  // FUNCIÓN PRINCIPAL
  // ============================================
  function syncGiftWithCart() {
    console.log('🎁 Verificando condición de regalo...');
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Calcular total de productos de pago
        var totalPaidQuantity = 0;
        var paidItems = [];
        var paidItemIds = [];
        
        cart.items.forEach(function(item) {
          if (PAID_PRODUCT_IDS.includes(item.variant_id.toString())) {
            totalPaidQuantity += item.quantity;
            paidItems.push(item);
            paidItemIds.push(item.variant_id.toString());
          }
        });
        
        // Buscar si hay algún producto de regalo
        var giftItem = cart.items.find(function(item) {
          return GIFT_PRODUCT_IDS.includes(item.variant_id.toString());
        });
        
        console.log('📊 Total productos de pago:', totalPaidQuantity);
        console.log('🎁 Producto de regalo presente:', giftItem ? 'SÍ' : 'NO');
        
        // Lógica de decisión
        if (totalPaidQuantity >= 3) {
          // Condición CUMPLIDA: DEBERÍA HABER REGALO
          if (!giftItem && !selectorActivo) {
            console.log('➕ Condición cumplida. Mostrando selector de regalo...');
            mostrarSelectorRegalo(paidItems, cart);
          }
        } else {
          // Condición NO CUMPLIDA: NO DEBERÍA HABER REGALO
          if (giftItem) {
            console.log('➖ Condición NO cumplida. Eliminando producto de regalo...');
            eliminarRegalo(giftItem);
          }
        }
      })
      .catch(error => {
        console.error('❌ Error al obtener el carrito:', error);
      });
  }
  
  // ============================================
  // MOSTRAR SELECTOR DE REGALO (CON URLs DIRECTAS)
  // ============================================
  function mostrarSelectorRegalo(paidItems, cart) {
    selectorActivo = true;
  
    // Lista completa de colores con sus códigos, nombres y URLs
    var todosLosColores = [
      { id: '56844488868217', nombre: 'Black Carbon', codigo: 'bc', imagen: IMAGENES_COLORES['bc'] },
      { id: '56844494111097', nombre: 'Brown Mole', codigo: 'bm', imagen: IMAGENES_COLORES['bm'] },
      { id: '56844485984633', nombre: 'Green Forest', codigo: 'gf', imagen: IMAGENES_COLORES['gf'] },
      { id: '56844481724793', nombre: 'Red Flower', codigo: 'fx', imagen: IMAGENES_COLORES['fx'] },
      { id: '56844501385593', nombre: 'Black Vulture', codigo: 'bv', imagen: IMAGENES_COLORES['bv'] },
      { id: '56844490899833', nombre: 'Blue Royal', codigo: 'br', imagen: IMAGENES_COLORES['br'] },
      { id: '56844496503161', nombre: 'Light Grey', codigo: 'lg', imagen: IMAGENES_COLORES['lg'] },
      { id: '56844466061689', nombre: 'Dark Grey', codigo: 'dg', imagen: IMAGENES_COLORES['dg'] }
    ];
    
    // Ordenar alfabéticamente
    todosLosColores.sort((a, b) => a.nombre.localeCompare(b.nombre));
    
    // Crear contenedor del selector
    var selectorHTML = `
      <div id="gift-selector-overlay" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 10000;
        display: flex;
        justify-content: center;
        align-items: center;
      ">
        <div style="
          background: white;
          border-radius: 12px;
          padding: 30px;
          max-width: 700px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          animation: slideUpFade 0.3s ease;
        ">
          <p style="margin-bottom: 25px; text-align: center; color: #666;">Has añadido 3 carteras. Elige el color de tu regalo:</p>
          
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; margin-bottom: 25px;">
    `;
    
    // Añadir cada color como una tarjeta con su imagen real
    todosLosColores.forEach(function(color) {
      selectorHTML += `
        <div class="gift-color-option" data-id="${color.id}" style="
          border: 2px solid #eaeaea;
          border-radius: 3px;
          padding: 15px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          transition: all 0.2s;
          background: white;
        " onmouseover="this.style.borderColor='#000'; this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 10px rgba(0,0,0,0.1)';" 
           onmouseout="this.style.borderColor='#eaeaea'; this.style.transform='translateY(0)'; this.style.boxShadow='none';">
          <div style="
            width: 100px;
            height: 100px;
            border-radius: 3px;
            overflow: hidden;
            border: 1px solid #eaeaea;
            background: #f5f5f5;
          ">
            <img src="${color.imagen || 'https://cdn.shopify.com/s/files/1/0899/8207/5257/files/cartera-minimalista-elegante_100x.jpg'}" 
                 alt="${color.nombre}" 
                 style="width: 100%; height: 100%; object-fit: cover;"
                 loading="lazy"
                 onerror="this.src='https://cdn.shopify.com/s/files/1/0899/8207/5257/files/cartera-minimalista-elegante_100x.jpg'; this.onerror=null;">
          </div>
          <span style="font-weight: 600; font-size: 14px; text-align: center;">${color.nombre}</span>
        </div>
      `;
    });
    
    selectorHTML += `
          </div>
          
          <div style="display: flex; gap: 10px; justify-content: center;">
            <button id="gift-selector-cancel" style="
              padding: 12px 30px;
              background: #f5f5f5;
              border: 1px solid #ddd;
              border-radius: 4px;
              cursor: pointer;
              font-weight: 600;
              font-size: 14px;
              transition: all 0.2s;
            " onmouseover="this.style.background='#e5e5e5'" onmouseout="this.style.background='#f5f5f5'">Cancelar</button>
          </div>
        </div>
      </div>
    `;
    
    // Añadir al DOM
    document.body.insertAdjacentHTML('beforeend', selectorHTML);
    
    // Eventos para las opciones de color
    document.querySelectorAll('.gift-color-option').forEach(function(option) {
      option.addEventListener('click', function() {
        var selectedId = this.dataset.id;
        añadirRegalo(selectedId);
        cerrarSelector();
      });
    });
    
    // Evento para cancelar
    document.getElementById('gift-selector-cancel').addEventListener('click', function() {
      cerrarSelector();
    });
    
    // Cerrar al hacer clic fuera
    document.getElementById('gift-selector-overlay').addEventListener('click', function(e) {
      if (e.target.id === 'gift-selector-overlay') {
        cerrarSelector();
      }
    });
  }
  
  // ============================================
  // CERRAR SELECTOR
  // ============================================
  function cerrarSelector() {
    selectorActivo = false;
    var overlay = document.getElementById('gift-selector-overlay');
    if (overlay) {
      overlay.remove();
    }
  }
  
  // ============================================
  // AÑADIR REGALO
  // ============================================
  function añadirRegalo(giftId) {
    console.log('🎁 Añadiendo regalo con ID:', giftId);
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: giftId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('✅ Regalo añadido correctamente:', data);
      mostrarMensaje('🎁 ¡Regalo añadido! Gracias por tu compra.');
      setTimeout(function() {
        location.reload();
      }, 1500);
    })
    .catch(error => {
      console.error('❌ Error al añadir el regalo:', error);
      cerrarSelector();
    });
  }
  
  // ============================================
  // ELIMINAR REGALO
  // ============================================
  function eliminarRegalo(giftItem) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(() => {
      console.log('✅ Regalo eliminado correctamente');
      mostrarMensaje('La cartera regalo ha sido eliminada porque ya no se cumplen las condiciones de compra [mínimo 3 carteras]');
      setTimeout(function() {
        location.reload();
      }, 1500);
    })
    .catch(error => {
      console.error('❌ Error al eliminar el regalo:', error);
    });
  }
  
  // ============================================
  // FUNCIÓN PARA MOSTRAR MENSAJES
  // ============================================
  function mostrarMensaje(texto) {
    var mensaje = document.createElement('div');
    mensaje.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #000;
      color: white;
      padding: 15px 25px;
      border-radius: 3px;
      z-index: 10001;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      box-shadow: 0 4px 15px rgba(0,0,0,0.2);
      animation: slideDown 0.3s ease;
      font-weight: 500;
    `;
    mensaje.textContent = texto;
    document.body.appendChild(mensaje);
    
    setTimeout(function() {
      mensaje.style.animation = 'slideUp 0.3s ease';
      setTimeout(function() {
        document.body.removeChild(mensaje);
      }, 300);
    }, 3000);
  }
  
  // ============================================
  // ESTILOS ANIMACIÓN
  // ============================================
  var style = document.createElement('style');
  style.textContent = `
    @keyframes slideDown {
      from { opacity: 0; transform: translate(-50%, -20px); }
      to { opacity: 1; transform: translate(-50%, 0); }
    }
    @keyframes slideUp {
      from { opacity: 1; transform: translate(-50%, 0); }
      to { opacity: 0; transform: translate(-50%, -20px); }
    }
    @keyframes slideUpFade {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
  
  // ============================================
  // EVENTOS
  // ============================================
  
  // Ejecutar al cargar la página
  setTimeout(syncGiftWithCart, 500);
  
  // Escuchar cambios en el carrito
  document.addEventListener('ajaxCart:updated', function() {
    setTimeout(syncGiftWithCart, 300);
  });
  
  // Escuchar clics en botones del carrito
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('.cart__remove') || 
        e.target.closest('.quantity__button') ||
        e.target.closest('[name="update"]')) {
      setTimeout(syncGiftWithCart, 500);
    }
  });
  
  // Observer para detectar cambios en el DOM del carrito
  var observer = new MutationObserver(function() {
    setTimeout(syncGiftWithCart, 300);
  });
  
  var cartContainer = document.querySelector('.cart-items, .cart__items, .cart, .cart-wrapper');
  if (cartContainer) {
    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
  
  console.log('✅ Sistema de regalo con selector visual de miniaturas activado');
});